import React, { Component } from "react";

//Components
import Home from "./Home";

export default class App extends Component {
  render() {
    return (
      <div>
        <Home />
      </div>
    );
  }
}
